import { createAction, props } from '@ngrx/store';

/***** Load Virtual Event Last Hero: BEGIN *****/
export const loadVirtualEventLastHero = createAction(
  '[VirtualEvent] Load VirtualEventLastHero',
  props<any>()
);

export const loadVirtualEventLastHeroSuccess = createAction(
  '[VirtualEvent] Load VirtualEventLastHero Success',
  props<any>()
);

export const loadVirtualEventLastHeroFailure = createAction(
  '[VirtualEvent] Load VirtualEventLastHero Failure',
  props<{ error: any }>()
);
/***** Load Virtual Event Last Hero: END *****/

/***** Declare Virtual Event Last Hero: BEGIN *****/
export const declareVirtualEventLastHero = createAction(
  '[VirtualEvent] Declare VirtualEventLastHero',
  props<any>()
);

export const declareVirtualEventLastHeroSuccess = createAction(
  '[VirtualEvent] Declare VirtualEventLastHero Success',
  props<any>()
);

export const declareVirtualEventLastHeroFailure = createAction(
  '[VirtualEvent] Finalize VirtualEventLastHero Failure',
  props<{ error: any }>()
);
/***** Declare Virtual Event Last Hero: END *****/

export const clearVirtualEventLastHero = createAction(
  '[VirtualEvent] Clear VirtualEventLastHero',
  props<any>()
);